import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/bus-icon.png'
import _imports_1 from '../assets/down.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "body-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "全台公車一次找", -1)
const _hoisted_4 = { class: "bus" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "article-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "找公車"),
  /*#__PURE__*/_createElementVNode("div", { class: "decoration-line" })
], -1)
const _hoisted_6 = { class: "article-content" }
const _hoisted_7 = { class: "button-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "台北", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "台中", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "button-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "高雄", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "台南", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "button-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", null, "新竹", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "other" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "其他"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("article", { class: "highway-bus" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "article-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "找客運"),
    /*#__PURE__*/_createElementVNode("div", { class: "decoration-line" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseLayout, null, {
      header: _withCtx(() => [
        _createVNode(_component_HeaderBar)
      ]),
      body: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("article", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCity('Taipei')))
                }, _hoisted_10),
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCity('Taichung')))
                }, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCity('Kaohsiung')))
                }, _hoisted_17),
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCity('Tainan')))
                }, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectCity('Hsinchu')))
                }, _hoisted_24),
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/other-city')))
                }, _hoisted_27)
              ])
            ])
          ]),
          _hoisted_28
        ])
      ]),
      _: 1
    })
  ]))
}